module.exports = __webpack_public_path__ + "img/bronzeIcon.72d97700.svg";